export default class AccessDirective {
    /* @ngInject */
    constructor() {
        this.restrict = 'A';
    }

    /* eslint-disable */
    link($scope, $element, $attr) {
        const account = JSON.parse(localStorage.getItem('account'));

        if (account.user && account.user.roleName !== 'ReadWrite') {
            $element.replaceWith(document.createComment(` sbAccess: ${$attr.sbAccess} `));
        }
    }
    /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/app/auth/access.directive.js